import React, { Fragment, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import LoginForm from "./LoginForm";
import AuthSplitLayout from "./AuthSplitLayout";
import bgImage from "../../assets/img/logos/api-award-2022.jpg";

const Login = () => {
  return (
    <Fragment>
      <LoginForm />
    </Fragment>
  );
};
export default Login;
